
var $ = require('jquery');
let listOfPageThatWasClicked = null;

$('body').on('click', '.facetwp-page', function() {
    listOfPageThatWasClicked = $(this).closest('.pagination').prev();
})

$(document).ready(function() {
    //onCallToAction();
});

$(document).on('facetwp-loaded', function(e) {
    let initFacetWPLoad = window.location.search == '' ? false : true;
    if ( initFacetWPLoad == false ) {
        initFacetWPLoad = true;
    } else {
        // if ( window.location.search ) {
        //     let listTop = $('.post-list').offset().top - $('.site-header__primary').outerHeight(true) - 80;
        //     window.scrollTo({ top: listTop, behavior: 'smooth' });
        // }
        if( listOfPageThatWasClicked !== null ) {
            let listTop = listOfPageThatWasClicked.offset().top - $('.site-header__primary').outerHeight(true);
            window.scrollTo({ top: listTop, behavior: 'smooth' });
        }
    }

    $('.facetwp-facet').each(function() {
        if ( !$('.facetwp-date-wrap').length ) {
            var facet = $(this);
            var facet_type = facet.attr('data-type');
            if (facet_type == 'date_range') {
                facet.find('.facetwp-date').wrap('<div class="facetwp-date-wrap"></div>');
    
                $('.facetwp-date-wrap').each(function() {
                    var facet_label = $('<label class="facetwp-date-label">');
                    facet_label.html($(this).find('.facetwp-date').attr('placeholder'));
                    // facet_label.insertBefore( $(this).find('input.facetwp-date') )
                })
            }
        }
    });
    onCallToAction();
});

/*
* Toggle accordion items on click of accordion__cta to expanded class
* Switch accordion__cta text on click from 'See More' to 'See Less'
* Toggle chevron icon on click from pointing down to pointing up
* Toggle content class on click from 'content' to 'content expanded'
*/
function onCallToAction() {

    const accordionCtas = document.querySelectorAll('.facet__accordion__cta');

    accordionCtas.forEach(function(cta) {
        const parentAccordion = cta.closest('.facet__accordion__items');
        const childrenAccordionItems = parentAccordion.querySelectorAll('.facet__accordion__item');
        const contents = parentAccordion.querySelectorAll('.content');

        cta.addEventListener('click', function() {

        var isOpen = cta.getAttribute('data-isopen'); // Get the current state from the attribute

        if (isOpen == 'true') {
            contents.forEach(function(content) {
                content.classList.remove('expanded');
            });

            childrenAccordionItems.forEach(function(item) {
                item.classList.remove('expanded');
            });
            cta.setAttribute('data-isopen', 'false'); // Update the attribute

            // Change the text of the cta
            cta.innerHTML = '<button>See More</button>' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; margin-left: 5px;">' +
            '<polyline points="18 15 12 9 6 15"></polyline>' +
            '</svg>';
            // Scroll back to the parent accordion
            window.scrollTo({
                top: parentAccordion.parentElement.offsetTop - 100,
                behavior: 'smooth'
            });

        }else {
            contents.forEach(function(content) {
                content.classList.add('expanded');
            });
            childrenAccordionItems.forEach(function(item) {
                item.classList.add('expanded');
            });
            cta.setAttribute('data-isopen', 'true'); // Update the attribute

            cta.innerHTML = '<button>See Less</button>' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; margin-left: 5px;">' +
            '<polyline points="18 15 12 9 6 15"></polyline>' +
            '</svg>';
            // Scroll to the first accordion___item
            window.scrollTo({
                top: childrenAccordionItems[0].offsetTop - 100,
                behavior: 'smooth'
            });
        }
        isOpen = !isOpen; // Toggle the flag
        });
    });
}
